// extracted by mini-css-extract-plugin
module.exports = {"row":"SelCryptoRow__row__vhtz+","icon":"SelCryptoRow__icon__LI8KT","description":"SelCryptoRow__description__Kbft6","action":"SelCryptoRow__action__fjakr"};